module.exports = __webpack_public_path__ + "img/enty_message.c7f14b32.png";